import {
    borders as delonghiBorders,
    colors as delonghiColors,
    radius as delonghiRadius,
    shadows as delonghiShadows,
    spacing as delonghiSpacing,
    iconsSize as delonghiIconsSize,
} from '../_delonghi'
import {
    borders as kenwoodBorders,
    colors as kenwoodColors,
    radius as kenwoodRadius,
    shadows as kenwoodShadows,
    spacing as kenwoodSpacing,
    iconsSize as kenwoodIconsSize,
} from '../_kenwood'

import {Semantics} from '../types/semantics.types'

const delonghiSemantics: Semantics = {
    colors: delonghiColors,
    borders: delonghiBorders,
    radius: delonghiRadius,
    shadows: delonghiShadows,
    spacing: delonghiSpacing,
    iconsSize: delonghiIconsSize,
    semanticOverrides: {},
}

const kenwoodSemantics: Semantics = {
    colors: kenwoodColors,
    borders: kenwoodBorders,
    radius: kenwoodRadius,
    shadows: kenwoodShadows,
    spacing: kenwoodSpacing,
    iconsSize: kenwoodIconsSize,
    semanticOverrides: {},
}

export {delonghiSemantics, kenwoodSemantics}
